/** HTTP Basic credentials for Spot Viewer APIs / SpotTickerExporter (SPOT_VIEWER role). */
export const SPOT_VIEWER_BASIC_USERNAME = "ht_spot_preview";
export const SPOT_VIEWER_BASIC_PASSWORD = "$p0tprev1ew";

/** HTTP Basic Authorization header for Spot Viewer APIs (and Viewer-auth exporters). */
export function spotViewerAuthorizationHeader(): string {
  const credentials = `${SPOT_VIEWER_BASIC_USERNAME}:${SPOT_VIEWER_BASIC_PASSWORD}`;
  return `Basic ${btoa(credentials)}`;
}
